import { Button, Drawer, Input, Slider, Segmented, Select, Card, Empty, Collapse, Tooltip, Modal, Upload, message as antdMessage, InputNumber, Popconfirm, Flex } from "antd";
import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { AlignLeftOutlined, PicCenterOutlined, InboxOutlined, PlusOutlined, DeleteOutlined, MenuOutlined, ColumnHeightOutlined, PictureOutlined, FieldTimeOutlined, CopyOutlined, ClockCircleOutlined, AudioOutlined, UploadOutlined } from '@ant-design/icons';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { IoImageOutline } from "react-icons/io5";
import axios from 'axios';

import "./main.css"
import {
    Position,
    Handle,
    useReactFlow,
    MarkerType
} from '@xyflow/react';
import UploadFileToS3 from '../../../../funcs/s3Upload'
import { v4 as uuidv4 } from 'uuid';
import { CustomHandle } from "../handler/main";
import DeleteNode from "../delete_node/main";



import { fireDB } from "../../../../funcs/firebase";
import { doc, setDoc, getDoc,updateDoc, arrayUnion  } from "firebase/firestore";

const { Dragger } = Upload;


let edgeStyle = { markerEnd: { type: MarkerType.Arrow }, zIndex: 10, background: "#6C9F89", width: 5, height: 5, borderRadius: "50%", transform: "translateY(-50%)" }

const saveImageURL = async (userId, url) => {
    console.log("-=-=-=-=", userId, url)
    try {
      const docRef = doc(fireDB, 'users', userId, 'medias',"uploaded_media" );
    //   await setDoc(docRef, [url] );
    await updateDoc(docRef, {
        urls: arrayUnion(url) // 'urls' is the field in Firestore storing the image list
    });

    } catch (error) {
      console.error("Error saving draft automation:", error);
    }
};
  


const handleProductImageUpload = async (files, product_id, messageApi) => {

    let media_urls = []
    for (const file of files) {
        let media_id = uuidv4();
        let media_type = file.name.split('.').pop();
        let url = await UploadFileToS3(messageApi, file.originFileObj, product_id, media_id, media_type);
        let user_detail = JSON.parse(localStorage.getItem("userData"))
        saveImageURL(user_detail.user_id, url)
        media_urls.push(url)
    }
    return media_urls
}



const RenderData = ({ messages,  setShowSubConfig, setSelectedIndex, toggleDrawer }) => {

    const RenderTextMessage = ({ message, messageIndex ,  setShowSubConfig, setSelectedIndex, toggleDrawer }) => {

        if (message.text == "" || message.text == undefined) {
            return
        }
        return (
            <div onClick={toggleDrawer} className="render-text-reply" style={{ textAlign: 'right' }}>
                <p style={{minHeight:'10px', textAlign:"left", padding:"10px",whiteSpace: "pre-line"}}>{message.text}</p>
                <div className="smart-replies" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                    {message?.smartReplies?.map((smartReply, index) => (
                        <div
                            key={`${message.id}-${index}`}
                            style={{ position: 'relative', marginBottom: '10px', width: 'fit-content' }} // Added width: fit-content
                        >
                            <Button
                                color="primary"
                                variant="dashed"
                                style={{
                                    display: 'block',
                                    width: 'auto',
                                    alignSelf: 'flex-end',
                                    paddingRight: '8px',
                                    paddingLeft: '8px',
                                    borderRadius: '10px',
                                    whiteSpace: 'normal',
                                    wordWrap: 'break-word',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    textAlign: 'right',
                                    margin: 0,
                                }}
                            >
                                {/* {`${message.id}-${index}`} */}
                                {smartReply}
                                <CustomHandle
                                    id={`${message.id}-${index}`}
                                    type={'source'}
                                    onDelete={() => console.log('Delete edge action')}
                                />
                            </Button>
                        </div>
                    ))}
                {message?.smartReplies?.length > 0 &&

                    <Tooltip title="If user not responded to this question, send follow up message, Click to edit follow up duration. Connect the next steps.">
                        <Button
                        className="follow-up-btn"
                            color="purple" variant="filled"
                            style={{
                                display: 'block',
                                width: 'auto',
                                alignSelf: 'flex-end',
                                paddingRight: '10px',
                                paddingLeft: '10px',
                                borderRadius: '10px',
                                whiteSpace: 'normal',
                                wordWrap: 'break-word',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                textAlign: 'right',
                                margin: 0,
                                fontSize: "12px",
                                cursor: "pointer",
                                marginBottom:"10px"
                                
                            }}
                            onClick={() => {
                                toggleDrawer(true);setSelectedIndex(messageIndex); setShowSubConfig(true);
                            }}
                        icon={<ClockCircleOutlined style={{ fontSize: "10px", marginRight:"4px" }} />}
                        >
                            {message?.follow_up_duration ? "Follow up after " : "Follow Up "} {message?.follow_up_duration} {message?.follow_up_duration_type == "m" ? "Min" :message?.follow_up_duration_type =="h" ? "Hrs" : message?.follow_up_duration_type == "s" ? "Sec" : ""}
                            <CustomHandle
                                id={`${message.id}-followup`}
                                type={'source'}
                                onDelete={() => console.log('Delete edge action')}
                            />
                        </Button>
                        </Tooltip>
                }
                </div>
            </div>
        )
    }

    const RenderButtonTemplate = ({ templateMessages , messageIndex ,  setShowSubConfig, setSelectedIndex, toggleDrawer }) => {

        return (
            <div className="button-tem-render" >
            <div onClick={toggleDrawer} className="templates-list">
                {templateMessages?.templates?.map((message) =>
                    <div className="render-button-reply">
                        {(message.thumb_url != undefined || message.thumb_url != "") && <img src={message.thumb_url} />}
                        <p className="template-title hide-scroll-bar">{message.title}</p>
                        <p style={{opacity:".6" , fontWeight:"500", fontSize:"8px"}} className="template-title hide-scroll-bar">{message.description}</p>

                        <div className="button-replies">
                            {
                                message?.buttons?.map((button, index) =>
                                    <>
                                        <Button  color="primary" variant="outlined"
                                        block
                                            style={{
                                                marginBottom:"2px",    
                                                marginTop:"4px",
                                                backgroundColor:"transparent"                              
                                            }}>
                                            { button.title.length > 15 ? `${button.title.slice(0,18)}...` : button.title.slice(0,18)}
                                            
                                            {button.type != "web_url" &&  <CustomHandle type="source" id={`${message.id}-${index}`} />}
                                            



                                        </Button>

                                    </>

                                )
                            }
                        </div>

                    </div>
                )}
            </div>
                 <Tooltip title="If user not responded to this question, send follow up message, Click to edit follow up duration. Connect the next steps.">
                    <Button
                    className="follow-up-btn"
                        color="purple" variant="filled"
                        style={{
                            display: 'block',
                            width: 'auto',
                            alignSelf: 'flex-end',
                            paddingRight: '10px',
                            paddingLeft: '10px',
                            borderRadius: '10px',
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            textAlign: 'right',
                            margin: 0,
                            fontSize: "12px",
                            cursor: "pointer",
                            marginBottom:"10px",
                            marginTop:"0px"
                            
                        }}
                        onClick={() => {
                            toggleDrawer(true);setSelectedIndex(messageIndex); setShowSubConfig(true);
                        }}
                    icon={<ClockCircleOutlined style={{ fontSize: "10px", marginRight:"4px" }} />}
                    >
                        {templateMessages?.follow_up_duration ? "Follow up after " : "Follow Up "} {templateMessages?.follow_up_duration} {templateMessages?.follow_up_duration_type == "m" ? "Min" :templateMessages?.follow_up_duration_type =="h" ? "Hrs" : templateMessages?.follow_up_duration_type == "s" ? "Sec" : ""}
                        <CustomHandle
                            id={`${templateMessages.id}-followup`}
                            type={'source'}
                            onDelete={() => console.log('Delete edge action')}
                        />
                    </Button>
                </Tooltip>
            </div>
        )
    }


    const RenderDelayTime = (message, messageIndex ,  setShowSubConfig, setSelectedIndex, toggleDrawer ) => {


        message = message.message

        return (
            <div onClick={toggleDrawer} className="render-delay">

                <div className="delay-header">
                {/* 💤 Delay */}
                    <FieldTimeOutlined style={{ fontSize: "14px", color: "#0800ff" }} /> Delay
                </div>
                <p style={{ fontSize: "6px", margin: 0, color: "rgba(0, 0, 0, 0.316)" }}>Below messages will be delayed for</p>
                <div className="delay-core">
                    {message.delayDuration} {message.durationType == "m" ? "Min" : "Sec"}
                </div>
            </div>
        )

    }


  const RenderAudioMessage= ({ message, messageIndex ,  setShowSubConfig, setSelectedIndex, toggleDrawer }) => {

        return (
            // <div onClick={toggleDrawer} className="render-text-reply" style={{ textAlign: 'right' }}>
            //     <AudioOutlined/>

            // </div>
              <div
      onClick={toggleDrawer}
      className="render-text-reply"
      style={{
        textAlign: "right",
        display: "flex",
        flexDirection:"row",
        alignItems: "flex-end",
        gap: "6px",
      }}
    >
      <AudioOutlined style={{ fontSize: 16, color:"#1890ff" }} />
      <div style={{ display: "flex", alignItems: "flex-end", gap: "2px", height: "14px" }}>
        <div style={{ width: "2px", height: "6px", background: "#1890ff", borderRadius: "2px" }}></div>
        <div style={{ width: "2px", height: "10px", background: "#1890ff", borderRadius: "2px" }}></div>
        <div style={{ width: "2px", height: "14px", background: "#1890ff", borderRadius: "2px" }}></div>
        <div style={{ width: "2px", height: "10px", background: "#1890ff", borderRadius: "2px" }}></div>
        <div style={{ width: "2px", height: "6px", background: "#1890ff", borderRadius: "2px" }}></div>
        <div style={{ width: "2px", height: "10px", background: "#1890ff", borderRadius: "2px" }}></div>
        <div style={{ width: "2px", height: "14px", background: "#1890ff", borderRadius: "2px" }}></div>
        <div style={{ width: "2px", height: "10px", background: "#1890ff", borderRadius: "2px" }}></div>
      </div>
    </div>
        )
    }


      const RenderImageMessage= ({ message, messageIndex ,  setShowSubConfig, setSelectedIndex, toggleDrawer }) => {

        return (

              <div
                onClick={toggleDrawer}
                className="render-text-reply"
                >

                    <img 
                    style={{borderRadius:"6px" , maxHeight:"400px", maxWidth:"90%" ,objectFit: "contain",}}
                    
                    src={message.image_url} />

                </div>
        )
    }
    return (

        <div style={{ marginTop: "10px" }}>
            {
                messages?.map((message, index) => {
                    if (message?.type === "button") {
                        return <RenderButtonTemplate messageIndex = {index} key={index} templateMessages={message}  setShowSubConfig = {setShowSubConfig} setSelectedIndex = {setSelectedIndex} toggleDrawer={toggleDrawer} />;
                    } else if (message?.type === "text") {
                        return <RenderTextMessage messageIndex = {index}  key={index} message={message}  setShowSubConfig = {setShowSubConfig} setSelectedIndex = {setSelectedIndex} toggleDrawer={toggleDrawer} />;
                    } else if (message?.type === "delay") {
                        return <RenderDelayTime messageIndex = {index}  key={index} message={message}  setShowSubConfig = {setShowSubConfig} setSelectedIndex = {setSelectedIndex} toggleDrawer={toggleDrawer} />;
                    }
                    else if (message?.type === "audio") {
                        return <RenderAudioMessage messageIndex = {index}  key={index} message={message}  setShowSubConfig = {setShowSubConfig} setSelectedIndex = {setSelectedIndex} toggleDrawer={toggleDrawer} />;
                    }
                    else if (message?.type === "image") {
                        return <RenderImageMessage messageIndex = {index}  key={index} message={message}  setShowSubConfig = {setShowSubConfig} setSelectedIndex = {setSelectedIndex} toggleDrawer={toggleDrawer} />;
                    } 
                    return null; // Ensures the map function always returns something
                })
            }
        </div>
    )

}

const getExtensionFromMime = (mimeType) => {
  if (!mimeType) return "bin"; // fallback
  const parts = mimeType.split("/");
  if (parts.length === 2) {
    // e.g. image/png → "png"
    return parts[1];
  }
  return "bin";
};


  const uploadFileToS3 = async (file, path) => {
    // const [messageApi, contextHolder] = antdMessage.useMessage();

    try {
    //   messageApi.open({
    //     type: 'loading',
    //     content: 'Uploading, Please wait...',
    //     duration: 0,
    //     key: 'payment-process'
    //   });
      const extension = getExtensionFromMime(file.type);


      let prod_url = `https://4iav7nkzgsu2jbpidrdt7seiri0lcfhk.lambda-url.ap-south-1.on.aws/generate_image_url?post_id=${path}&ext=${extension}&custom_name=file`

      const presSignedResponse = await axios.get(prod_url, {
        headers: {
          "Authorization": localStorage.getItem("token")
        }
      });

      // console.log("======",presSignedResponse.data )

      // console.log("putting  file",file.type)

      const signedUrl = presSignedResponse.data.url;

      const response = await axios.put(signedUrl, file, {
        headers: {
          'Content-Type': file.type,
        },
      });


      if (response.status === 200) {
        // console.log("putting  file 200")
        // console.log('File uploaded successfully');
        // messageApi.destroy()
        // messageApi.success("File uploaded successfully")
        // let url = `https://public-assets.instantdm.com/instantdm/public/${path}/media/image.jpg`
        // let url = `https://r2-public-image.sanjayhotaction.workers.dev/instantdm/public/${path}/media/image.jpg`
        let url = `https://public-assets.instantdm.com/instantdm/public/${path}/media/file.${extension}`
        return url


      } else {
        console.log("putting  file", response)
        console.log('Error uploading file');
        // messageApi.destroy()
        // messageApi.error("Failed to upload")
      }
    } catch (error) {
      console.log('Error uploading file:', error);
    //   messageApi.destroy()
    //   messageApi.error("Failed to upload")
    }
    return undefined
  };



  const handleImageUpload = async (file, customSave=null) => {


    console.log("inside else-=-=-=-")

      let url = await uploadFileToS3(file, `${uuidv4()}`);
      
        try {
        customSave(url)
    }
      catch (error){
        console.log("Errpr while saving the changes.....",error)
      }
    
  
  }

const MessageType = React.memo(({ message, messageIndex, index, onmessageChange, mediaURLS, setMediaURLS, setShowSubConfig, setSelectedIndex }) => {
    const [messageApi, contextHolder] = antdMessage.useMessage();
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const onMediaUploadChange = ({ fileList }) => {
        let current_automation_id =  localStorage.getItem("current_automation_id")
        handleProductImageUpload(fileList, current_automation_id, messageApi).then((local_mediaUrls) => {
            setMediaURLS([...local_mediaUrls,...mediaURLS])
            setUploadedFiles(fileList.map((file) => file.uid))
        })
    }


    const [replyType, setReplyType] = useState(message?.type || "text");
    const [smartReplies, setSmartReplies] = useState(message?.smartReplies || []);
    const [templates, setTemplates] = useState(message?.templates || []);
    const [inputText, setInputText] = useState(message.text || "")
    const [imageURL, setImageURL] = useState(message.image_url || "")
    const [audioURL, setAudioURL] = useState(message.audio_url || "")


    const [showMediaModel, setShowMediaModel] = useState(false)

    const [selectedTemplate, setSelectedTemplate] = useState()

    // const [showSubConfig, setShowSubConfig] = useState(false)

    // const [selectedIndex, setSelectedIndex] = useState(-1)

    useEffect(() => {
        onmessageChange({ ...message, type: replyType, smartReplies, templates, text:inputText, audio_url:audioURL, image_url:imageURL });
    }, [replyType, smartReplies, templates, message, inputText]);

    const addSmartReply = useCallback(() => {
        setSmartReplies((prevReplies) => [...prevReplies, ""]);
    }, []);

    const updateSmartReply = useCallback((index, value) => {
        setSmartReplies((prevReplies) => prevReplies.map((reply, i) => (i === index ? value : reply)));
    }, []);

    const removeSmartReply = useCallback((index) => {
        setSmartReplies((prevReplies) => prevReplies.filter((_, i) => i !== index));
    }, []);

    const addTemplate = useCallback(() => {
        if (templates.length < 10) {
            setTemplates((prevTemplates) => [...prevTemplates, { title: "", description: "", buttons: [] , id:uuidv4() }]);
        }
    }, [templates]);

    const removeTemplate = useCallback((index) => {
        setTemplates((prevTemplates) => prevTemplates.filter((_, i) => i !== index));
    }, []);

    const updateTemplateField = useCallback((index, field, value) => {
        setTemplates((prevTemplates) => prevTemplates.map((template, i) => (i === index ? { ...template, [field]: value } : template)));
    }, []);

    const addButton = useCallback((templateIndex) => {
        setTemplates((prevTemplates) =>
            prevTemplates.map((template, i) =>
                i === templateIndex && template.buttons.length < 5
                    ? { ...template, buttons: [...template.buttons, { title: "", type: "postback", url: "" }] }
                    : template
            )
        );
    }, []);

    const removeButton = useCallback((templateIndex, buttonIndex) => {
        setTemplates((prevTemplates) =>
            prevTemplates.map((template, i) =>
                i === templateIndex ? { ...template, buttons: template.buttons.filter((_, j) => j !== buttonIndex) } : template
            )
        );
    }, []);

    const updateButtonField = useCallback((templateIndex, buttonIndex, field, value) => {
        setTemplates((prevTemplates) =>
            prevTemplates?.map((template, i) =>
                i === templateIndex
                    ? {
                        ...template,
                        buttons: template.buttons.map((button, j) => (j === buttonIndex ? { ...button, [field]: value } : button)),
                    }
                    : template
            )
        );
    }, []);

    return (
        <div className="message-type">

            <Segmented
                size="middle"
                value={replyType}
                shape="round"
                style={{ marginBottom: "10px" }}
                onChange={(value) => setReplyType(value)}
                options={[
                    { value: "text", icon: <AlignLeftOutlined />, "label": "Text" },
                    { value: "button", icon: <PicCenterOutlined />, "label": "Button" },
                    { value: "image", icon: <PictureOutlined />, "label": "Image" },
                    { value: "audio", icon: <AudioOutlined />, "label": "Audio" },

                ]}
            />

            {replyType === "text" ? (
                <div>
                    <Input.TextArea value={inputText} onChange={(e) => { setInputText(e.target.value) }} placeholder="Add your text or link you want to share" />

                    {/* Smart Replies Section */}
                    <div className="smart-reply" style={{ display: "flex", flexDirection: "column", justifyContent: "flex-end", alignItems: "flex-end" }}>
                        {smartReplies.map((reply, index) => (
                            <div key={index} className="smart-reply-item" style={{ display: "flex", gap: "8px", marginTop: "8px", justifyContent: "flex-end" }}>
                                <Button
                                    className="smart-reply-delete"
                                    type="text"
                                    danger
                                    icon={<DeleteOutlined />}
                                    onClick={() => removeSmartReply(index)}
                                />
                                <Input
                                    value={reply}
                                    onChange={(e) => updateSmartReply(index, e.target.value)}
                                    placeholder="Enter smart reply"
                                    style={{ flex: 1, borderRadius: "20px", maxWidth: '260px' }}
                                />

                            </div>
                        ))}

                        <Button
                            color="primary"
                            variant="dashed"
                            icon={<PlusOutlined />}
                            onClick={addSmartReply}
                            style={{ marginTop: "8px", borderRadius: "20px", width: "180px" }}
                        >
                            Add Smart Reply
                        </Button>
                       { smartReplies?.length > 0 && <Button className="follow-up-btn" onClick={() => { setSelectedIndex(index); setShowSubConfig(true); console.log("-=-=-=-selected index", message?.follow_up_duration,message?.follow_up_duration_type) }} style={{ marginTop: "8px" }} color="purple" variant="dashed" icon={<ClockCircleOutlined/>} block>
                            {message?.follow_up_duration ? "Follow up after " : "Follow Up "} {message?.follow_up_duration} {message?.follow_up_duration_type == "m" ? "Min" :message?.follow_up_duration_type =="h" ? "Hrs" : message?.follow_up_duration_type == "s" ? "Sec" : ""}
                        </Button>
                    }
                    </div>
                </div>
            ) : replyType === "audio" ?  (
                <div>
                    {
                        audioURL && 
                        <Flex vertical>
                        
                        <audio style={{maxWidth:"80%", marginBottom:"10px", marginTop:"10px"}} controls src={audioURL}>Your browser does not support the audio element.</audio> 
                        <Button onClick={() => {
                            setAudioURL("")
                        }} color="danger" variant="outlined">Delete Audio</Button>
                        </Flex>
                    }
                {
                !audioURL && 
                    <Upload
                      action=""
                      accept="audio/*"
                      beforeUpload={() => false}
                      listType="picture"
                      defaultFileList={
                        audioURL
                          ? [
                              {
                                name: uuidv4() ,
                                uid: uuidv4(),
                                thumbUrl: audioURL,
                                url: audioURL,
                                status: "done",
                              },
                            ]
                          : []
                      }
                      onChange={({ file }) => {
                        messageApi.open({
                            type: 'loading',
                            content: 'Uploading, Please wait...',
                            duration: 0,
                            key: 'payment-process'
                        });
                        handleImageUpload(file, (url) => {
                        setAudioURL(url)
                        messageApi.destroy()

                      })}}
                      maxCount={1}
                    >
                      
                        <Button
                          type="default"
                          variant="outlined"
                          style={{ marginTop: "20px" }}
                          icon={<UploadOutlined />}
                          block
                        >
                          Upload Audio
                        </Button>
                      
                    </Upload>

                
                }

                </div>
            ) : replyType === "image" ?  (
                <div>
                    {
                        imageURL && 
                        <Flex vertical>
                        
                        <img src={imageURL} style={{borderRadius:"10px" , maxHeight:"400px" ,objectFit: "contain",}} />
                        <Button onClick={() => {
                            setImageURL("")
                        }} color="danger" variant="outlined">Delete Image</Button>
                        </Flex>
                    }
                {
                !imageURL && 
                    <Upload
                      action=""
                      accept="image/*"
                      beforeUpload={() => false}
                      listType="picture"
                      defaultFileList={
                        imageURL
                          ? [
                              {
                                name: uuidv4() ,
                                uid: uuidv4(),
                                thumbUrl: imageURL,
                                url: imageURL,
                                status: "done",
                              },
                            ]
                          : []
                      }
                      onChange={({ file }) => {
                        messageApi.open({
                            type: 'loading',
                            content: 'Uploading, Please wait...',
                            duration: 0,
                            key: 'payment-process'
                        });
                        handleImageUpload(file, (url) => {
                        setImageURL(url)
                        messageApi.destroy()

                      })}}
                      maxCount={1}
                    >
                      
                        <Button
                          type="default"
                          variant="outlined"
                          style={{ marginTop: "20px" }}
                          icon={<UploadOutlined />}
                          block
                        >
                          Upload Image
                        </Button>
                      
                    </Upload>

                
                }

            </div>
            ) : (
                <div className="btn-msg">
                    {/* Button Templates Section */}
                    <div className="templates-container" style={{ display: "flex", gap: "10px", overflowX: "auto", paddingBottom: "20px" , scrollbarWidth:"inital"}}>
                        {templates.map((template, templateIndex) => (
                            <Card
                                key={templateIndex}
                                style={{ width: "280px", minWidth: "280px" }}
                                className="message-core-card"
                            >

                                {template.thumb_url == undefined && <IoImageOutline onClick={() => {
                                    setSelectedTemplate(templateIndex)
                                    setShowMediaModel(true)
                                }} style={{ display: "flex", width: "100%", marginBottom: "10px", fontWeight: "500", color: "#80808087", fontSize: "44px" }} />

                                }

                                {template.thumb_url != undefined && <img onClick={() => {
                                    setSelectedTemplate(templateIndex)
                                    setShowMediaModel(true)
                                }} className="template-thumb-image" src={template.thumb_url} />

                                }
                                <Input
                                    placeholder="Message title"
                                    value={template.title}
                                    style={{ marginBottom: "10px" }}
                                    onChange={(e) => updateTemplateField(templateIndex, "title", e.target.value)}
                                />
                                <Input.TextArea
                                    placeholder="Message Description"
                                    value={template.description}
                                    onChange={(e) => updateTemplateField(templateIndex, "description", e.target.value)}

                                />

                                {/* Buttons Section */}
                                <div style={{ marginTop: "10px" }}>
                                    <Collapse accordion style={{ marginTop: "10px" }}>
                                        {template.buttons.map((button, buttonIndex) => (
                                            <Collapse.Panel
                                                key={buttonIndex}
                                                header={button.title || "New Button"}
                                                extra={
                                                    <Button
                                                        type="text"
                                                        danger
                                                        icon={<DeleteOutlined />}
                                                        onClick={() => removeButton(templateIndex, buttonIndex)}
                                                    />
                                                }
                                            >
                                                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                                    <Input
                                                        placeholder="Button Name"
                                                        value={button.title}
                                                        onChange={(e) => updateButtonField(templateIndex, buttonIndex, "title", e.target.value)}
                                                    />
                                                    <Select
                                                        value={button.type}
                                                        onChange={(value) => updateButtonField(templateIndex, buttonIndex, "type", value)}
                                                        options={[
                                                            { value: "postback", label: "Regular" },
                                                            { value: "web_url", label: "URL" },
                                                        ]}
                                                        style={{ width: "100%" }}
                                                    />
                                                    {button.type === "web_url" && (
                                                        <Input
                                                            placeholder="URL"
                                                            value={button.url}
                                                            onChange={(e) => updateButtonField(templateIndex, buttonIndex, "url", e.target.value)}
                                                        />
                                                    )}
                                                </div>
                                            </Collapse.Panel>
                                        ))}
                                    </Collapse>


                                    {template.buttons.length < 3 && (
                                        <Button
                                            type="dashed"
                                            icon={<PlusOutlined />}
                                            onClick={() => addButton(templateIndex)}
                                            style={{ marginTop: "8px" }}
                                        >
                                            Add Button
                                        </Button>
                                    )}

                                </div>

                                <Tooltip title="Delete This template">
                                    <Button className="delete-message-card" type="text" danger icon={<DeleteOutlined />} onClick={() => removeTemplate(templateIndex)} />
                                </Tooltip>
                            </Card>
                        ))}

                        {templates.length < 10 && (
                            <Button type="dashed" icon={<PlusOutlined />} onClick={addTemplate}>
                                Add Template
                            </Button>
                        )}
                    
                    </div>
                    <Button className="follow-up-btn" onClick={() => { setSelectedIndex(index); setShowSubConfig(true); console.log("-=-=-=-selected index", message?.follow_up_duration,message?.follow_up_duration_type) }} style={{ marginTop: "8px" }} color="purple" variant="dashed" icon={<ClockCircleOutlined/>} block>
                        {message?.follow_up_duration ? "Follow up after " : "Follow Up "} {message?.follow_up_duration} {message?.follow_up_duration_type == "m" ? "Min" :message?.follow_up_duration_type =="h" ? "Hrs" : message?.follow_up_duration_type == "s" ? "Sec" : ""}
                    </Button>
                </div>
            )}
            <Modal onOk={() => { setShowMediaModel(false) }} onCancel={() => { setShowMediaModel(false) }} onClose={() => { setShowMediaModel(false) }} title="Select Media" open={showMediaModel}>
                {contextHolder}
                <Dragger
                    multiple
                    beforeUpload={() => { return false }}
                    accept='image/*'
                    onChange={onMediaUploadChange}
                    fileList={[]}
                >
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Click or drag Images to this area to upload</p>


                </Dragger>
                <div className="uploaded-images">
                    {
                        mediaURLS.map((media) => <img onClick={() => {
                            let temp_templates = [...templates]
                            temp_templates[selectedTemplate].thumb_url = media
                            setTemplates([...temp_templates])
                        }} src={media} />)
                    }
                </div>
            </Modal>
        </div>
    );
})



const MessageDelay = React.memo(({ message, index, onmessageChange }) => {

    const [delayDuration, setDelayDuration] = useState(message.delayDuration || 2)
    const [durationType, setDurationType] = useState(message.durationType || "m")
    const [updateMessage, setUpdateMessage] = useState(false)

    useEffect(() => {
        if (updateMessage == true) {
            setUpdateMessage(false)
            onmessageChange({ ...message, delayDuration: delayDuration, durationType: durationType });
        }

    }, [delayDuration, durationType]);


    return (

        <div className="delay-duration">
            <div>
                <p className="delay-heading"><FieldTimeOutlined style={{ fontSize: "26px", color: "#0800ff" }} /> Delay</p>
                <p className="card-description">Add a delay before sending next message</p>
            </div>

            <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
                <InputNumber value={delayDuration} onChange={(value) => { setDelayDuration(value); setUpdateMessage(true) }} />
                <Select defaultValue={durationType} onChange={(value) => { setDurationType(value); setUpdateMessage(true) }} options={[{ "label": "Seconds", "value": "s" }, { "label": "Minutes", "value": "m" },]} />
            </div>
        </div>
    )

})

const SubMessageConf = React.memo(({ message, index, onmessageChange, mediaURLS, setMediaURLS, setShowSubConfig }) => {

    const [skipQuestion, setSkipQuestion] = useState(message?.skip_option || {})


    const [followUpDuration, setFollowUpDuration] = useState(message?.follow_up_duration || 30);
    const [followUpDurationType, setFollowUpDurationType] = useState(message?.follow_up_duration_type || "m");


    useEffect(() => {
        onmessageChange({ ...message,
            follow_up_duration: followUpDuration, follow_up_duration_type: followUpDurationType
        });
    }, [followUpDuration, followUpDurationType]);


    return (
        <div>

            <Card className="sub-msg-conf-card">
                <h3 > <ClockCircleOutlined style={{color:"purple"}}/> Follow Up</h3>
                <p>If user not resoponded to this question, send follow up message.</p>
                <>
                    <h4>Follow up after</h4>

                    <div style={{ display: "flex", width:"100%", flexDirection: "row", gap: "10px" }}>
                            <InputNumber value={followUpDuration} onChange={(value) => { setFollowUpDuration(value) }} />
                            <Select style={{flex:"1"}} defaultValue={followUpDurationType} onChange={(value) => { setFollowUpDurationType(value); }} options={[{ "label": "Seconds", "value": "s" }, { "label": "Minutes", "value": "m" },{ "label": "Hour", "value": "h" }]} />
                    </div>
                </>
                
                <p style={{ color:"rgba(0,0,0,.4)"}}>Note : Maximum allowed is 24 hours, set 0 for no follow up.</p>
            </Card>
        </div>
    )

})


export default function MessageReply({ id, data }) {


    const { updateNodeData } = useReactFlow();
    const [messages, setMessages] = useState(data?.messages)

    const [mediaURLS, setMediaURLS] = useState([])
    const [selectedIndex, setSelectedIndex] = useState(-1)

    const [ showSubConfig, setShowSubConfig] = useState(false)

    const [messageApi, contextHolder] = antdMessage.useMessage();


    useEffect(() => {
        const fetchMediaURLs = async () => {
            let user_detail = JSON.parse(localStorage.getItem("userData"))
            if (!user_detail.user_id) return;

            try {
                const docRef = doc(fireDB, "users", user_detail.user_id, "medias", "uploaded_media");
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    const data = docSnap.data();
                    setMediaURLS(data.urls || []); // Set state with URLs (or empty array)
                } else {
                    console.log("No uploaded media found.");
                }
            } catch (error) {
                console.error("Error fetching media URLs:", error);
            }
        };
        fetchMediaURLs();
    }, []);

    useEffect(() => {
        setMessages(data?.messages)
    }, [data])
    const toggleDrawer = () => {
        let toogle = data?.toogleDrawer == undefined ? false : data?.toogleDrawer
        updateNodeData(id, { ...data, toogleDrawer: !toogle, messages: messages })
    };

    const addMessage = ({ addType }) => {

        let new_messages = { id: Date.now() }
        if (addType == "delay") {
            new_messages["type"] = addType
            new_messages["delayDuration"] = 2
            new_messages["durationType"] = "m"
        }
        setMessages()
        if (data.messages != undefined) {
            updateNodeData(id, { ...data, messages: [...data.messages, new_messages] })
            setMessages([...data.messages, new_messages])
        }
        else {
            updateNodeData(id, { ...data, messages: [new_messages] })
            setMessages([new_messages])
        }
    }

    // Remove a message
    const removeMessage = (id_) => {
        let non_del_msg = [...data.messages.filter((msg) => msg.id !== id_)]
        if (non_del_msg.length < 1) {
            updateNodeData(id, { ...data, messages: [] })
            setMessages([])
        }
        else {
            updateNodeData(id, { ...data, messages: [...non_del_msg] })
            setMessages(non_del_msg)
        }

    };

    // Handle Drag & Drop
    const onDragEnd = (result) => {
        if (!result.destination) return;

        const updatedMessages = Array.from(data.messages);
        const [movedItem] = updatedMessages.splice(result.source.index, 1);
        updatedMessages.splice(result.destination.index, 0, movedItem);
        console.log("-=-=-=-=-= drag end", updatedMessages)
        updateNodeData(id, { ...data, messages: [...updatedMessages] })
        setMessages([...updatedMessages])
    };

    
    const toggleSubDrawer = () => {

        // setShowSubConfig(-1)
        setSelectedIndex(-1)
        // updateNodeData(id, { ...data, showSubConfig: !toogle, messages: messages })
    };


    return (
        <div className="flow-comp" >
                {contextHolder}


            {/* <DeleteNode editNode={toggleDrawer} updateNodeData={updateNodeData} id={id} data={data} /> */}


            {/* <DeleteOutlined/> */}

            

            <CustomHandle type="target" id={`${id}`} />

            <div className="comp-header">
            <DeleteNode editNode={toggleDrawer} updateNodeData={updateNodeData} id={id} data={data} />

            <p className="comp-title" onClick={toggleDrawer}>Reply Message</p>
            </div>
            

            {messages != undefined && <RenderData setShowSubConfig = {setShowSubConfig} setSelectedIndex={setSelectedIndex} toggleDrawer={toggleDrawer} messages={messages || []}  />}
            {/* setShowSubConfig = {setShowSubConfig} setSelectedIndex = { setSelectedIndex }/> */}

            {(messages || []).length < 1 && 
            
            <Empty
                description={
                <h6>
                    Looks Empty, Add a Message
                </h6>
                }
            >
                <Button type="primary" onClick={toggleDrawer}>Add Message</Button>
            </Empty>
            
            
            }

            {/* Drawer with Drag & Drop */}
            <Drawer
                width={"500px"}
                style={{backgroundColor: '#f5f5ff'}}
                //open={openDrawer}
                placement="left"
                open={data?.toogleDrawer}
                onClose={toggleDrawer}
                // onClose={() => {setOpenDrawer(false)}}
                title="Manage Messages"
            >

                {data?.messages && data?.messages.length >= 1 && <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="messages-list">
                        {(provided) => (
                            <div {...provided.droppableProps} ref={provided.innerRef} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                {data?.messages?.map((message, index) => (
                                    <Draggable key={message.id} draggableId={message.id.toString()} index={index}>
                                        {(provided) => (
                                            <div

                                                className="message-reply-card"
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                style={{

                                                    ...provided.draggableProps.style
                                                }}
                                            >
                                                {/* Drag Handle */}
                                                <span
                                                    {...provided.dragHandleProps}
                                                    className="handler"
                                                >
                                                    <ColumnHeightOutlined />
                                                </span>

                                                <div style={{ flex: 1, overflowX: "scroll" }}>
                                                    {
                                                        message.type == "delay" && <MessageDelay
                                                            message={message}
                                                            index={index}
                                                            mediaURLS={mediaURLS}
                                                            setMediaURLS={setMediaURLS}

                                                            onmessageChange={(updatedMessage) => {
                                                                let temp_data = { ...data }
                                                                temp_data["messages"][index] = updatedMessage
                                                                // console.log("message changes....")
                                                                // updateNodeData(id, { ...temp_data })
                                                                setMessages([...temp_data["messages"]])
                                                            }}
                                                        />
                                                    }
                                                    {
                                                        message.type != "delay" && <MessageType
                                                            message={message}
                                                            index={index}
                                                            mediaURLS={mediaURLS}
                                                            setMediaURLS={setMediaURLS}
                                                            setShowSubConfig = {setShowSubConfig} setSelectedIndex = { setSelectedIndex }
                                                            onmessageChange={(updatedMessage) => {
                                                                let temp_data = { ...data }
                                                                temp_data["messages"][index] = updatedMessage
                                                                // console.log("message changes....")
                                                                // updateNodeData(id, { ...temp_data })
                                                                setMessages([...temp_data["messages"]])
                                                            }}
                                                        />
                                                    }
                                                </div>

                                                <Button
                                                    className="delete-message-reply"
                                                    type="text"
                                                    danger
                                                    icon={<DeleteOutlined />}
                                                    onClick={() => removeMessage(message.id)}
                                                />
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
                }
                <Button type="dashed" icon={<PlusOutlined />} onClick={() => addMessage({ addType: "message" })} style={{ width: "100%", marginTop: "10px" }}>
                    Add Message
                </Button>
                <Button type="dashed" icon={<PlusOutlined />} onClick={() => addMessage({ addType: "delay" })} style={{ width: "100%", marginTop: "10px" }}>
                    Add Delay
                </Button>

                <Drawer

                width={"400px"}
                style={{ backgroundColor: '#f5f5ff' }}
                placement="left"
                open={selectedIndex >= 0 ? true : false}
                onClose={toggleSubDrawer}
                title="Reply Configuration"
                >
                
                    {(selectedIndex != -1 && data?.messages && data?.messages.length >= 1) && <SubMessageConf
                        message={data?.messages[selectedIndex]}
                        // index={selectedIndex}
                        mediaURLS={mediaURLS}
                        setMediaURLS={setMediaURLS}
                        setShowSubConfig={setShowSubConfig}
                        onmessageChange={(updatedMessage) => {

                            let temp_data = { ...data }
                            temp_data["messages"][selectedIndex] = updatedMessage
                            setMessages([...temp_data["messages"]])
                        }}
                    />
                    }
            </Drawer>
            </Drawer>
            {/* <CustomHandle type="source" id={`${id}`} /> */}

            <Button color="default" variant="solid"
                block
                style={{
                    marginBottom:"0",    
                    marginTop:"20px"                              
                }}>
                Next Step {<CustomHandle type="source" id={`${id}`} />}
            </Button>

        </div>
    );
}

